import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Icon from '../components/Icon';
import PublicNavbar from '../components/PublicNavbar';
import { trackEvent } from '../utils/analytics';

// Samma terapeutdata - kommer senare att hämtas från backend
const therapists = [
  {
    id: 1,
    slug: "jenny-fuxe",
    name: "Jenny Fuxe",
    title: "Legitimerad Psykoterapeut",
    specialties: ["Schematerapi", "KBT", "Relationsterapi"],
    shortBio: "Jenny är specialist på Schematerapi och KBT med fokus på relationella problem och anknytning.",
    image: "/images/jenny-fuxe.jpg",
    experience: "10+ år",
    education: "Leg. Psykoterapeut",
    languages: ["Svenska"],
    longBio: `Vad älskar du mest med att vara terapeut?

Att uppleva människors förändring. Jag har alltid varit fascinerad av mänskligt beteende och de komplexa mekanismer som styr våra liv. Min nyfikenhet har drivit mig att utforska varför vi utvecklar olika sidor av oss själva, varför vi visar upp vissa och döljer andra.

Jag jobbar mycket med affektbryggor mellan nu och då. Varför vi t ex triggas starkt känslomässigt i en situation idag och kanske vill fly beror ofta på att gamla sår aktiveras. Detta behöver vi förstå för att kunna läka. Som schematerapeut är mitt fokus just detta. Vi undersöker tillsammans om det finns frustrerade behov från barndomen. Känslomässiga behov som vi alla har när vi växer upp är t ex att bli sedda, hörda, speglade i våra känslor, känna oss trygga och inkluderade. Vi behöver också empatisk gränssättning och lekfullhet. Om vi har med oss frustrationer t ex varit oskyddade, övergivna känslomässigt, mobbade för att ge några ex kan vi utveckla känslomässiga sår. Ofta har vi starka skyddssidor på grund av detta.

Som psykoterapeut är jag engagerad och nyfiken. Det kan vara tufft att gå i terapi men det ska vara spännande och roligt också. Det är ett detektivarbete vi gör tillsammans.

Om mig:
Jag är leg psykoterapeut med inriktning på Kognitiv Beteendeterapi (KBT) och Schematerapi, en mer fördjupande terapiform med mer fokus på uppväxterfarenheter och anknytning.

Jag har också utbildning i EFT, emotional focused therapy med inriktning mot par.

Tidigare har jag varit verksam på Valsta VC, en vårdcentral i Sigtuna som KBT-terapeut. Jag har också jobbat på Egil Linges relationsmottagning under 5 år.

Idag jobbar jag helt och hållet privat och driver egen mottagning på Riddargatan på Östermalm.

Jag har samarbeten med bland annat Stockholm Medical Office (en företagshälsovård), Trygghetsrådet och Svenska Kognitiva Institutet vid Sabbatsbergs sjukhus.

Jag jobbar med både enskilda och par, familjer och grupper.

Mina klienter söker ofta hjälp för relationella problem, låg självkänsla, ångest, nedstämdhet, självkritik, perfektionism och stress.

Att arbeta tillsammans:
Vi kommer tillsammans överens om var vi börjar varje session utifrån vad som känns mest angeläget, det som så att säga "ligger överst." Samtidigt som vi kopplar till föregående samtal och terapimål. Ibland ger jag hemuppgifter, men det passar inte alla.`,
    certifications: [
      "Legitimerad Psykoterapeut (Sverige)",
      "Specialist i Kognitiv Beteendeterapi (KBT)",
      "Utbildning i Schematerapi",
      "Certifierad i EFT (Emotional Focused Therapy)"
    ],
    approaches: [
      "Schematerapi",
      "Kognitiv Beteendeterapi (KBT)",
      "EFT (Emotional Focused Therapy)",
      "Relationsterapi",
      "Parterapi"
    ]
  },
  {
    id: 2,
    slug: "miriam-walden",
    name: "Miriam Walden",
    title: "Legitimerad Psykoterapeut & Certifierad Schematerapeut",
    specialties: ["Schematerapi", "KBT", "CFT", "ACT"],
    shortBio: "Miriam är legitimerad psykoterapeut och certifierad schematerapeut med bred klinisk erfarenhet från kris, trauma och relationssvårigheter.",
    image: "/images/miriam-walden.jpg",
    experience: "10+ år",
    education: "Lunds- och Stockholms Universitet",
    languages: ["Svenska", "Engelska"],
    longBio: `Jag är legitimerad Psykoterapeut samt certifierad Schematerapeut med flerårig erfarenhet av psykoterapeutiskt arbete med individer, par och familjer. Jag har bred klinisk erfarenhet från bland annat kris- och trauma, sorg, ätstörningar, neuropsykiatri, relationssvårigheter, stress och utmattning. 

Jag har varit verksam inom psykiatrin, som kurator i skolvärlden samt som psykoterapeut inom företagshälsovård och primärvård. Jag har arbetat i privat regi såväl som i offentlig verksamhet. Tidigare har jag också arbetat som organisationskonsult med stöd till chefer och ledningsgrupper samt med organisationsutveckling. 

Jag har min grundutbildning som Beteendevetare från Lunds- och Stockholms Universitet. För närvarande är jag verksam som privatpraktiserande kliniker och inom företagshälsovård.

Mitt arbete utgår från KBT och Schematerapi samt från CFT (Compassionfokuserad terapi) och ACT (Acceptance and Commitment therapy). Jag integrerar kunskap om meditation och mindfulness i det kliniska arbetet och i mötet med mig får de existentiella frågorna ofta betydande utrymme. Behandlingsmetoden anpassas efter dig och dina specifika behov och jag möter dig där du befinner dig. Vi utgår från livsteman varit svåra att förändra på egen hand.

Vanliga sökorsaker är emotionell instabilitet, kriser, relationssvårigheter, ångest/panikångest, depression, tvång, låg självkänsla och känslomässiga svårigheter.`,
    certifications: [
      "Legitimerad Psykoterapeut (Sverige)",
      "Certifierad Schematerapeut",
      "Beteendevetare från Lunds- och Stockholms Universitet",
      "Utbildning i CFT (Compassionfokuserad terapi)",
      "Utbildning i ACT (Acceptance and Commitment therapy)"
    ],
    approaches: [
      "Schematerapi",
      "Kognitiv Beteendeterapi (KBT)",
      "CFT (Compassionfokuserad terapi)",
      "ACT (Acceptance and Commitment therapy)",
      "Meditation och mindfulness",
      "Existentiell terapi"
    ]
  }
];

const TherapistBioPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  
  const therapist = therapists.find(t => t.slug === id);

  React.useEffect(() => {
    if (therapist) {
      trackEvent('Therapist Bio Page View', {
        therapist_id: therapist.id,
        therapist_slug: therapist.slug,
        therapist_name: therapist.name
      });
    }
  }, [therapist]);

  if (!therapist) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-neutral-50 via-bg-primary to-brand-accent flex items-center justify-center">
        <div className="text-center">
          <Icon name="user-x" size={64} className="text-muted mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-primary mb-2">Terapeut hittades inte</h2>
          <p className="text-secondary mb-6">Den terapeut du söker efter kunde inte hittas.</p>
          <button 
            onClick={() => navigate('/therapists')}
            className="inline-flex items-center gap-2 px-6 py-3 bg-brand-primary text-white rounded-lg hover:bg-brand-primary-dark transition-colors"
          >
            <Icon name="arrow-left" size={16} />
            <span>Tillbaka till terapeuter</span>
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen ai-bg">
      <PublicNavbar />
      
      <div className="max-w-6xl mx-auto px-6 py-12 pt-24">
        {/* Breadcrumb Navigation */}
        <nav className="flex items-center gap-2 text-sm text-text-secondary mb-8">
          <button 
            onClick={() => navigate('/therapists')}
            className="hover:text-brand-primary transition-colors"
          >
            Terapeuter
          </button>
          <Icon name="chevron-right" size={16} />
          <span className="text-primary">{therapist.name}</span>
        </nav>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* Vänster kolumn - Terapeutinfo */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 sticky top-6">
              {/* Profilbild */}
              <div className="aspect-square bg-gradient-to-br from-neutral-50 to-brand-accent rounded-xl relative overflow-hidden mb-6">
                {therapist.image && therapist.image !== "/api/placeholder/400/400" ? (
                  <img 
                    src={therapist.image} 
                    alt={therapist.name}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="absolute inset-0 flex items-center justify-center">
                    <Icon name="user-round" size={120} className="text-gray-300" />
                  </div>
                )}
              </div>

              {/* Grundinfo */}
              <h1 className="text-2xl font-bold text-primary mb-2">{therapist.name}</h1>
              <p className="text-brand-primary font-medium mb-4">{therapist.title}</p>
              
              {/* Specialiteter */}
              <div className="mb-6">
                <h3 className="text-sm font-semibold text-primary mb-3">Specialiteter</h3>
                <div className="flex flex-wrap gap-2">
                  {therapist.specialties.map((specialty, index) => (
                    <span
                      key={index}
                      className="inline-block bg-neutral-100 text-text-secondary text-xs px-2 py-1 rounded-md border border-neutral-200"
                    >
                      {specialty}
                    </span>
                  ))}
                </div>
              </div>

              {/* Snabb info */}
              <div className="space-y-4 mb-6">
                <div className="flex items-center gap-3">
                  <Icon name="graduation-cap" size={18} className="text-gray-400" />
                  <div>
                    <p className="text-sm text-text-secondary">Utbildning</p>
                    <p className="font-medium text-primary">{therapist.education}</p>
                  </div>
                </div>
                
                <div className="flex items-center gap-3">
                  <Icon name="globe" size={18} className="text-gray-400" />
                  <div>
                    <p className="text-sm text-text-secondary">Språk</p>
                    <p className="font-medium text-primary">{therapist.languages.join(', ')}</p>
                  </div>
                </div>
              </div>

              {/* CTA Knapp */}
              <button 
                onClick={() => {
                  trackEvent('Book Session Button Click', {
                    therapist_id: therapist.id,
                    therapist_name: therapist.name,
                    location: 'therapist-bio-page'
                  });
                  // TODO: Koppla till BookSession komponenten när den är implementerad
                  // För nu, navigera till contact page eller annan lämplig sida
                  navigate('/contact');
                }}
                className="w-full bg-brand-primary text-white py-3 px-4 rounded-lg hover:bg-brand-primary-dark transition-colors font-medium flex items-center justify-center gap-2"
              >
                <Icon name="calendar" size={18} />
                <span>Boka samtal</span>
              </button>
            </div>
          </div>

          {/* Höger kolumn - Detaljerad information */}
          <div className="lg:col-span-2 space-y-8">
            {/* Om terapeuten */}
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
              <h2 className="text-2xl font-bold text-primary mb-6">Om {therapist.name}</h2>
              <div className="prose prose-gray max-w-none">
                {therapist.longBio.split('\n\n').map((paragraph, index) => (
                  <p key={index} className="text-text-secondary leading-relaxed mb-4 last:mb-0">
                    {paragraph}
                  </p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TherapistBioPage;